import * as React from "react";

interface FullscreenIconProps {
	color: string;
	isFullscreen?: boolean; // is the fullscreen currently open
	hoverColor?: string;
	style: any;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
	onClick?: () => void;
}

class FullscreenIcon extends React.Component<FullscreenIconProps, any> {
	constructor(props: FullscreenIconProps) {
		super(props);
	}

	state = {
		color: "white", // default to white
	};

	componentWillMount() {
		this.setState({ color: this.props.color });
	}

	addHoverColor(e) {
		const { color, hoverColor } = this.props;
		const newColor = hoverColor || color;
		this.setState({ color: newColor });

		if (this.props.onMouseEnter) {
			this.props.onMouseEnter(); // fire the prop passed from the parent
		}
	}

	removeHoverColor(e) {
		this.setState({ color: this.props.color });

		if (this.props.onMouseLeave) {
			this.props.onMouseLeave(); // fire the prop passed from the parent
		}
	}

	render() {
		const { style, onClick, isFullscreen } = this.props;

		const { color } = this.state;

		return (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="24"
				height="24"
				color="#66D9EF"
				viewBox="0 0 18 18"
				style={{
					transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
					fill: color,
					...style,
				}}
				onClick={onClick}
				onMouseOver={this.addHoverColor.bind(this)}
				onMouseLeave={this.removeHoverColor.bind(this)}
			>
				{isFullscreen ? (
					<path d="M3 12.5h2.5V15H7v-4H3v1.5zm2.5-7H3V7h4V3H5.5v2.5zM11 15h1.5v-2.5H15V11h-4v4zm1.5-9.5V3H11v4h4V5.5h-2.5z" />
				) : (
					<path d="M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z" />
				)}
			</svg>
		);
	}
}

export default FullscreenIcon;



// WEBPACK FOOTER //
// ./src/components/Lab/FullscreenIcon.tsx